// extracted by mini-css-extract-plugin
module.exports = {"value":"styles_value__RXPyV","value_green":"styles_value_green__3Lzjl","item":"styles_item__qh2rg","name":"styles_name__2kU7E","container":"styles_container__PFX7J"};